module.exports = __webpack_public_path__ + "media/images/responsive/keywords/keyword_ohana-fcc938b08f0b2352e550e369f2723b96.jpg";